export default __webpack_public_path__ + "static/media/MORGAN STANLEY.4811db48.jpg";